import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, tap, map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { StorageService } from '../storage/storage.service';
import { HelperService } from './helper.service';
import { AuthenticationStorageService } from '../storage/jwt-storage-service';
import { JWT, PasswordReset } from '../interfaces/custom.interfaces';
import { ResetAccountPassword } from '@core/interfaces/api.interfaces';

@Injectable(
  {
    providedIn: 'root'
  }
)
export class AuthenticationService {

  private LOGIN_BODY_TEMPLATE = 'grant_type=password&username={{userId}}&password={{password}}&clientId={{clientId}}&fingerprint=1c8167aafb5b9d9b072bac585441cb5f';

  constructor(
    protected helper: HelperService,
    protected http: HttpClient,
    protected storageService: StorageService,
    protected authenticationStorageService: AuthenticationStorageService) {
  }

  authenticate(username: string, password: string) {
    this.authenticationStorageService.clearJWT();
    const body = this.formatLoginRequestBody(username, password);
    let header = new HttpHeaders();
    header = header.append('Content-Type', 'application/x-www-form-urlencoded');
    const url = this.helper.clientService.config.apiTokenUrl;
    return this.http.post<JWT>(url, body, { headers: header })
      .pipe(
        tap(resp => {
          const jwt = resp;
          this.authenticationStorageService.setJWT(jwt);
          return true;
        }));
  }

  forgotPassword(model: string) {
    let header = new HttpHeaders();
    header = header.append('Content-Type', 'application/x-www-form-urlencoded');
    const url = this.helper.clientService.forgotPassword(model);
    return this.http.put(url, null, { headers: header });
  }

  resetPassword(model: PasswordReset) {
    const url = this.helper.clientService.resetPassword;
    return this.http.put<string>(url, model);
  }

  resetExpiredPassword(model: ResetAccountPassword) {
    const url = this.helper.clientService.rootResetPassword;
    return this.http.post<string>(url, model);
  }

  logout() {
    const url = this.helper.clientService.logOff;
    return this.http.put(url, {}).pipe(map(() => {
      this.storageService.clearTimeoutStorage();
      this.authenticationStorageService.clearJWT();
    }),
      catchError((_err: any) => {
        this.storageService.clearTimeoutStorage();
        this.authenticationStorageService.clearJWT();
        return of(null);
      }));
  }

  private formatLoginRequestBody(userId: string, password: string) {
    return this.LOGIN_BODY_TEMPLATE
      .replace('{{userId}}', encodeURIComponent(userId))
      .replace('{{password}}', encodeURIComponent(password))
      .replace('{{clientId}}', this.helper.clientService.config.clientId);
  }
}
